import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IRTMTimeLogNewRes } from './index.type';


const useAllRtmTimeLog = ({ pageNumber, perpageData, searchTerm = "" }: { pageNumber: number; perpageData: number; searchTerm?: string }) => {
  const [RtmTimeLogData, setRtmTimeLogData] = React.useState<IRTMTimeLogNewRes>();

  const { loading: RtmTimeLogDataLoading, makeApiCall } = useApi({
    url: `/RTM/getAllTimeLog?page=${pageNumber}&${searchTerm ? `&search=${searchTerm}` : ""}`,
    method: 'GET',
  });
  
  const getRtmTimelogData = async () => {
    const { response, error } = await makeApiCall<undefined, IRTMTimeLogNewRes>();
    if (response?.status === 'success') {
      setRtmTimeLogData(response);
    }
    
    if (response?.status === 'fail') {
      setRtmTimeLogData(undefined);
    }
    
    if (error) toast.error('Something went wrong while fetching RTM data. Please try again later');
  };

  return {
    RtmTimeLogData,
    getRtmTimelogData,
    RtmTimeLogDataLoading,
  };
};

export default useAllRtmTimeLog;
